module.exports = "<aside class=\"layout-main-aside\">\r\n<app-t2-menu></app-t2-menu>\r\n</aside>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/trip2-theme/components/t2-sidebar/t2-sidebar.component.html
// module id = 2580
// module chunks = 66